import React, { createContext, useContext, useState, ReactNode } from "react";

interface SidebarContextType {
    isSideBarOpen: boolean;
    setSideBarOpen: (open: boolean) => void;
    setSideBarWidth:  (width: number) => void;
    sideBarWidth: number
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export const SidebarProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [isSideBarOpen, setSideBarOpen] = useState(false);
    const [sideBarWidth, setSideBarWidth] = useState(0)
    return (
        <SidebarContext.Provider value={{ isSideBarOpen, setSideBarOpen, sideBarWidth, setSideBarWidth }}>
            {children}
        </SidebarContext.Provider>
    );
};

export const useSidebar = (): SidebarContextType => {
    const context = useContext(SidebarContext);
    if (!context) {
        throw new Error("useSidebar must be used within a SidebarProvider");
    }
    return context;
};
